// extracted by mini-css-extract-plugin
export default {"blockLoading":"BlockLoading_blockLoading__mB4fO","loader":"BlockLoading_loader__KKdF4","rot1":"BlockLoading_rot1__MBwvH"};